import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAnxiousSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M31.37 19.2c0 2.28 1.75 3.89 3.94 3.89 2.41 0 3.94-1.61 3.94-4.05 0-1.73-1.17-2.85-2.09-4.08-1.73-2.32-1.86-6.24-1.86-6.24s0 3.7-1.92 6.18c-.93 1.23-2.01 2.6-2.01 4.3Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M39.89 22.2c-.93 1.49-2.57 2.39-4.58 2.39-3.1 0-5.44-2.32-5.44-5.39 0-2.18 1.27-3.83 2.29-5.15l.05-.06c.66-.85 1.04-1.91 1.27-2.85C30.82 9.18 27.55 8 24 8 15.18 8 8 15.18 8 24s7.18 16 16 16 16-7.18 16-16c0-.61-.04-1.21-.11-1.8Zm-9.96 6.77-2.65 2.32c-.22.2-.54.24-.8.12a.745.745 0 0 1-.44-.68V30l-1.57 1.3c-.22.18-.54.22-.8.1a.753.753 0 0 1-.43-.68v-.67l-1.41 1.23c-.22.2-.54.24-.8.12a.745.745 0 0 1-.44-.68V30l-1.57 1.3c-.14.12-.31.17-.48.17-.22 0-.43-.09-.58-.27a.758.758 0 0 1 .1-1.06l2.8-2.32a.752.752 0 0 1 1.23.58v.67l1.41-1.23a.745.745 0 0 1 1.24.56v.72l1.57-1.3a.752.752 0 0 1 1.23.58v.67l1.41-1.23c.31-.28.79-.24 1.06.07.26.31.23.78-.08 1.06Z",
    fill: "currentColor"
  }));
}

export { SvgAnxiousSelectedEmojiSecondary as default };
